import { EmptyState } from '../components/EmptyState';
import { PageTitle } from '../components/PageTitle';
import { AnimatedBox } from '../components/AnimatedBox';

const ShoppingMalls = () => {
  return (
    <AnimatedBox>
      <PageTitle>쇼핑몰 관리</PageTitle>
      <EmptyState message="아직 등록된 쇼핑몰이 없습니다." />
    </AnimatedBox>
  );
};

export default ShoppingMalls;
